module.exports = __FOREMAN_VENDOR__REACT_ELLIPSIS_WITH_TOOLTIP__;